import { HStack, Pressable, Text } from '@ayble-health/dashboard-components';
import React from 'react';
import { useToken } from '@chakra-ui/react';
import { ChevronRightIcon } from 'lucide-react';
import { useUserBlocks } from '../../../api/healthCoach/useUserBlocks';
import {
  BLOCK_STABLE_STRINGS,
  UserBlock,
} from '../../../models/block';
import { Loader } from '../../Loader';
import { formatDate } from '../utils';
import { stripHtml } from './utils';

type Props = {
  openEditBlockDrawer: (block: UserBlock) => void;
};

export const UncoveredGoalsTab = ({ openEditBlockDrawer }: Props) => {
  const [bluegrey] = useToken('colors', ['bluegrey']);
  const { blocks, isLoading } = useUserBlocks({
    archived: false,
    stableString: BLOCK_STABLE_STRINGS.uncoveredGoals,
  });

  const uncoveredGoalsBlock = blocks?.[0];
  const uncoveredGoalsInstructions = uncoveredGoalsBlock?.instructions
    ? stripHtml(uncoveredGoalsBlock.instructions)
    : null;

  if (isLoading) {
    return <Loader loading />;
  }

  return (
    <Pressable
      background={'white'}
      py={4}
      px={5}
      w={'100%'}
      rounded={'lg'}
      gap={2}
      disabled={!uncoveredGoalsBlock}
      onClick={() =>
        uncoveredGoalsBlock && openEditBlockDrawer(uncoveredGoalsBlock)
      }
    >
      <Text
        color={uncoveredGoalsInstructions ? 'secondary.500' : 'blueGray.600'}
        fontSize={'sm'}
        fontStyle={uncoveredGoalsInstructions ? undefined : 'italic'}
        whiteSpace={'pre-wrap'}
      >
        {uncoveredGoalsInstructions || 'No uncovered goals.'}
      </Text>
      <HStack alignItems={'center'} justifyContent={'space-between'}>
        {uncoveredGoalsBlock?.date_assigned && (
          <Text color={'blueGray.600'} fontSize={'xs'}>
            {formatDate(uncoveredGoalsBlock.date_assigned, 'MMM D, YYYY')}
          </Text>
        )}

        {uncoveredGoalsBlock && (
          <ChevronRightIcon size={16} color={bluegrey} strokeWidth={1.5} />
        )}
      </HStack>
    </Pressable>
  );
};

export default UncoveredGoalsTab;
